module.exports = __webpack_public_path__ + "img/vlad-checkpoint-model-selector.23d2d67c.png";